var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserStarLine = function SvgUserStarLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.333v1.333a4 4 0 0 0-4 4H2.667A5.333 5.333 0 0 1 8 9.333Zm0-.667c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-1.333a2.666 2.666 0 1 0 0-5.334 2.666 2.666 0 1 0 0 5.334Zm4 7-1.96 1.03.375-2.182-1.585-1.545 2.19-.319.98-1.984.98 1.984 2.19.319-1.585 1.545.374 2.182L12 14.333Z",
    fill: "currentColor"
  })));
};
export default SvgUserStarLine;